import React from 'react';
import { cn } from '../../utils/cn';

type TextFieldProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  hint?: string;
  error?: string;
  className?: string;
  inputClassName?: string;
};

export function TextField({
  label,
  hint,
  error,
  className,
  inputClassName,
  ...props
}: TextFieldProps) {
  return (
    <label className={cn('block', className)}>
      {label ? (
        <div className="mb-1.5 text-sm font-medium text-slate-800 dark:text-slate-200">{label}</div>
      ) : null}
      <input
        className={cn(
          'w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 shadow-sm outline-none transition dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:placeholder:text-slate-500',
          'focus:border-red-400 focus:ring-2 focus:ring-red-200',
          error ? 'border-rose-300 focus:border-rose-400 focus:ring-rose-200' : '',
          inputClassName
        )}
        {...props}
      />
      {error ? (
        <div className="mt-1 text-xs text-rose-600">{error}</div>
      ) : hint ? (
        <div className="mt-1 text-xs text-slate-500 dark:text-slate-400">{hint}</div>
      ) : null}
    </label>
  );
}


